/**
 * Page register
 * 
 * @module page-register
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'page-register';

if (!customElements.get(customElements.component)) {

    class pageRegister extends HTMLElement {

        constructor() {

            super();

            this.initEvents();
        }

        /**
         * Init events
         * 
         * @return {undefined}
         */
         initEvents() {
            this.querySelectorAll("input[type='checkbox'][required]").forEach(input => {

                input.addEventListener('click', () => {
                    if(input.checked) {
                        this.querySelector("[data-submit]").removeAttribute('disabled');
                    } else {
                        this.querySelector("[data-submit]").setAttribute("disabled", "disabled");
                    }
                });

            });
        }

    }

    customElements.define(customElements.component, pageRegister);
}